module.exports = __webpack_public_path__ + "static/img/5.11625ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/5.png
// module id = 487
// module chunks = 1